import { render, staticRenderFns } from "./SampleModal.vue?vue&type=template&id=c1b6211e"
import script from "./SampleModal.vue?vue&type=script&lang=js"
export * from "./SampleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports